/**
 * クリニック本体を表す構造化データ（JSON-LD / Schema.org: MedicalClinic）。
 *
 * 方針：
 * - 実在する医療機関であるため @type は MedicalClinic を使用する（Organization / LocalBusiness 単体では使用しない）。
 * - TOPページ（https://sbdcl.biz/）に1つだけ出力する。全ページへ機械的に重複出力しない。
 * - 確定済みの正式情報のみを記載し、未確定情報は一切追加しない。
 * - 営業時間は画面上で確定しているが、正式な営業曜日・休診日が未確定のため
 *   openingHours / openingHoursSpecification は追加しない。
 * - 診療科（medicalSpecialty）は正式確認前のため追加しない。
 * - 口コミ（Review / AggregateRating）は一切追加しない（Google口コミは外部導線のみ）。
 * - sameAs は Instagram のみ（LINE / WEB予約 / Google口コミ / 外部LP は sameAs ではない）。
 */
export default function MedicalClinicJsonLd() {
  const data = {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "@id": "https://sbdcl.biz/#medicalclinic",
    name: "渋谷美容皮膚科クリニック",
    url: "https://sbdcl.biz/",
    telephone: "03-6416-4392",
    address: {
      "@type": "PostalAddress",
      postalCode: "150-0043",
      addressRegion: "東京都",
      addressLocality: "渋谷区",
      streetAddress: "道玄坂2-6-14 HYビル7F",
      addressCountry: "JP",
    },
    sameAs: ["https://www.instagram.com/shibuya.beauty.clinic/"],
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}